import React, { CSSProperties, PropsWithChildren } from 'react';

import { makeClassNames } from '../../../utils/styles';
import './player-card-wrapper.scss';

const classNames = (params: { hasHeadShot: boolean; legacy: boolean }) => {
  const { hasHeadShot, legacy } = params;

  return makeClassNames({
    item: [
      'players-card',
      hasHeadShot ? 'players-card--has-head-shot' : '',
      !legacy ? 'player-card__player--full-link' : '',
    ],
  });
};

export interface IPlayerCardWrapper {
  playerTeamColor: string;
  hasHeadShot: boolean;
  legacy?: boolean;
}

const PlayerCardWrapper = (props: PropsWithChildren<IPlayerCardWrapper>) => {
  const { playerTeamColor, hasHeadShot, children, legacy = false } = props;
  const styleBackground: CSSProperties = { backgroundColor: playerTeamColor };
  const cn = classNames({ hasHeadShot, legacy });

  return (
    <div className={cn.item} style={styleBackground}>
      {children}
    </div>
  );
};

export default PlayerCardWrapper;
